<template>
  <div class="home">
    <!--fix-header-->
    <header class="header_container">
      <div class="logo-area clearfix">
        <!-- <a href="https://www.jetfi.jp/wifi/" class="gnav-logo">
          <img
            src="https://www.jetfi.jp/wifi/images/logo_h_bk.svg"
            alt="高速、大容量、これ一台で！全世界で使える海外Wi-Fi jetfi by GFC"
          />
        </a> -->
        <a href="https://www.jetfi.jp/wifi/" class="gnav-logo">
          <img src="images/logo_h_bk.svg" alt="高速、大容量、これ一台で！全世界で使える海外Wi-Fi jetfi by GFC">
        </a>

        <p class="tagline">
          高速、大容量、これ一台で！
          <br />全世界で使える海外Wi-Fi
        </p>
      </div>
    </header>

    <main class="main_container">
      <router-view :key="$route.fullPath"></router-view>
    </main>
    <footer class="common-footer">
      <div class="inner">
        <div id="footer-contact">
          <div class="footer-contact-container">
            <div class="footer-contact-box">
              <p><strong>ご不明点がございましたら、<br class="sp">こちらからお問い合わせください。</strong></p>
              <img src="images/operator.png" alt="サポートセンター オペレーター" class="footer-contact-operator-sp sp">
            </div>
            <div class="app-button-box mgt30">
              <a class="app-button" href="https://www.jetfi.jp/wifi/contact/">お問い合わせ</a>
            </div>
          </div>
          <img src="images/operator.png" alt="サポートセンター オペレーター" class="footer-contact-operator-pc pc">
        </div>
      </div>
      <div class="copyright-area">
        <a href="https://www.jetfi.jp/wifi/">高速&大容量の格安海外WiFiレンタルは【jetfi】</a>
        <span class="copyright">Copyright © 2018 MAYA SYSTEM Inc.</span>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
//import Vue from "vue";

export default {
  name: "home",
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      languages: [],
      selected_lang: "", //process.env.I18N_LOCALE,
      show: false
    };
  },
  created: function() {},
  mounted: function() {},
  methods: {
    goHome: function() {
      var params = Object.assign({}, this.$router.currentRoute.query);
      delete params["aid"];
      delete params["cid"];
      delete params["pcode"];
      this.$router.push({
        path: "/areas",
        query: params
      });
    }
  },

  components: {
    // HelloWorld
  }
};
</script>
